import { miscConstants } from '../../constants';
import { miscService } from '../../services';
import { alertActions } from '..';
import { generalErrorHandler, resetAbortController } from '../utils';

export default function listTutorialVideos() {
  return dispatch => {
    const ac = resetAbortController(miscConstants.LIST_TUT_VID_REQUEST);
    dispatch(request());
    dispatch(alertActions.clear());

    return miscService.listTutorialVideos(ac.signal).then(
      tutorialVideos => {
        dispatch(success(tutorialVideos));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: miscConstants.LIST_TUT_VID_REQUEST };
  }
  function success(tutorialVideos) {
    return { type: miscConstants.LIST_TUT_VID_SUCCESS, tutorialVideos };
  }
  function failure(error) {
    return { type: miscConstants.LIST_TUT_VID_FAILURE, error };
  }
}
